module.exports = __webpack_public_path__ + "static/media/ico-webpay.2bd4507a.svg";